import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brand" }

import { ref, onMounted, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

const SCROLL_THRESHOLD = 82;


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNavigation',
  setup(__props) {

const route = useRoute();
const isFolded = ref(false);
const isHomePage = ref(false);

const handleScroll = () => {
  isFolded.value = window.scrollY >= SCROLL_THRESHOLD;
};

const detectHomePage = () => {
  isHomePage.value = route.path === '/';
};

onMounted(() => {
  detectHomePage();
  window.addEventListener('scroll', handleScroll);
});

watch(() => route.path, detectHomePage);

// Clean up event listener
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ folded: isFolded.value, isHome: isHomePage.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, null, -1)
        ]))]),
        _: 1
      })
    ])
  ], 2))
}
}

})